import instance from "../utils/network";

export interface RFTNewsResponse {
  list: NewsResponse[];
  top3: NewsResponse[];
  total: number;
}

export interface NewsResponse {
  id: number | null;
  title: string | null;
  contentHtml: string;
  mainImageKey: string;
  category: string | null;
  authorName: string | null;
  isPublished: boolean | null;
  views: number | null;
  createdAt: string;
  link: string | null;
  year?: number | null;
  month?: number | null;
  mainTitle?: string | null;
  mainCoverImageUrl?: string | null;
}

export interface InterviewResponse {
  id: number | null;
  year?: number | null;
  month?: number | null;
  mainTitle?: string | null;
  mainCoverImageUrl?: string | null;
}

export interface HotAndPagedNewsResponse {
  hotNews: NewsResponse[];
  news: NewsResponse[];
  totalPages: number;
  totalElements: number;
  currentPage: number;
}

export interface NewsCategory {
  name: string;
  id: number;
}

export function getNews(
  page: number,
  size: number,
  hot?: number,
  category?: number
): Promise<HotAndPagedNewsResponse> {
  return instance.get(
    `/news?page=${page}&size=${size}&hot=${hot ? hot : ""}&category=${
      category ? category : ""
    }`
  );
}

export function getNewsById(id: string): Promise<NewsResponse> {
  return instance.get(`/news/${id}`);
}

export function getNewsCategory(): Promise<NewsCategory[]> {
  return instance.get(`/news-category`);
}

export function getInterviewList(): Promise<NewsResponse[]> {
  return instance.get("/news/interview");
}

export function getInterviewListByYear(year: number): Promise<NewsResponse[]> {
  return instance.get(`/news/interview/${year}`);
}

export function getMainList(): Promise<NewsResponse[]> {
  return instance.get("/news/main");
}

export function shareNews(id: number) {
  return instance.patch(`/news/${id}`);
}

export function getRFTNews(
  page: number,
  limit: number,
  search?: string
): Promise<RFTNewsResponse> {
  return instance.get(
    `/nest/news/runner-competition?page=${page}&limit=${limit}&search=${search}`
  );
}

export function getRFTNewsById(id: number): Promise<NewsResponse[]> {
  return instance.get(`/nest/news/runner-competition/${id}`);
}
